import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import Balancer from 'react-wrap-balancer'

export const Hero = () => {
  const { formatMessage } = useIntl()

  return (
    <section>
      <div className="relative flex flex-col flex-1 h-screen">
        <video
          className="absolute z-0 object-cover w-full h-full"
          autoPlay
          muted
          loop
          preload='metadata'
        >
          <source src="/hero.mp4" type="video/mp4" />
        </video>
        <div className="relative z-0 flex flex-col justify-center flex-1 max-w-[1264px] w-full px-4 mx-auto">
          <h2 className="mb-10 text-2xl font-bold text-white md:mb-12 md:text-5xl font-openSans leading-[120%]">
            <Balancer>
              {formatMessage({ id: 'HERO_TITLE' })}
            </Balancer>
          </h2>
          <div className="grid grid-cols-1 gap-2 sm:w-fit sm:gap-[60px] sm:grid-cols-2">
            <Link
              className="font-openSans text-center h-fit text-base py-3 sm:px-9 font-semibold uppercase bg-white rounded-lg whitespace-nowrap hover:bg-[#FF3C00] hover:text-white shadow-[0px_6px_4px_0px_rgba(224,224,224,0.20)]"
              to="/expert"
              target='_blank'
            >
              {formatMessage({ id: 'BECOME_AN_EXPERT' })}
            </Link>
            <Link
              className="font-openSans text-center h-fit text-base py-3 sm:px-9 font-semibold uppercase bg-white rounded-lg whitespace-nowrap hover:bg-[#FF3C00] hover:text-white shadow-[0px_6px_4px_0px_rgba(224,224,224,0.20)]"
              to="/contact-us"
            >
              {formatMessage({ id: 'BECOME_A_CLIENT' })}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
